import { render, staticRenderFns } from "./PurchaseInvoiceDetail.vue?vue&type=template&id=4eba39a6"
import script from "./PurchaseInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoiceDetail.vue?vue&type=style&index=0&id=4eba39a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports